import '../index_mWeb.css';
import {
  EmptyData,
  ErrorMessage,
  FlatListWrapper,
  PaginationIndicator,
  PlaceHolder,
  TransactionPokerItem,
  View
} from '../../../../component';
import PullToRefresh from 'react-simple-pull-to-refresh';
import FlatList from 'flatlist-react';
interface Props {
  error: any;
  resultArrived: any;
  _onRefresh: any;
  hasMoreItems: any;
  loadMoreItems: any;
  onPressRetryGame: any;
  pokerTransactionList: any;
}
const PokerHistoryMWeb = ({
  error,
  resultArrived,
  _onRefresh,
  hasMoreItems,
  onPressRetryGame,
  pokerTransactionList,
  loadMoreItems
}: Props) => {
  const renderItemGame = (item: any) => <TransactionPokerItem item={item} isPoker />;

  const renderWhenEmpty = () => {
    if (error) return <ErrorMessage onPressRetry={onPressRetryGame} />;
    if (!resultArrived) return <PlaceHolder.Loader />;
    return <EmptyData message={'No Poker Transaction found'} />;
  };

  return (
    <View className={'transaction-history-container__mWeb'}>
      <PullToRefresh onRefresh={_onRefresh}>
        <FlatListWrapper>
          <FlatList
            renderItem={renderItemGame}
            list={pokerTransactionList}
            renderWhenEmpty={renderWhenEmpty}
            hasMoreItems={hasMoreItems}
            loadMoreItems={loadMoreItems}
            // renderOnScroll
            paginationLoadingIndicator={<PaginationIndicator />}
          />
        </FlatListWrapper>
      </PullToRefresh>
    </View>
  );
};

export default PokerHistoryMWeb;
